<template>
  <Modal 
    :id="'cmp-add-licenceAccounts'"
    @cancelled="onCancel"
  >
    
    <template slot="header">Select {{$t('asset')}} {{$t('type')}} </template>

    <template slot="body">
      <div class="contact-search">
        <InputField
          
          :id="'asset_search'"
          :value="searchString"
          :placeholder="'Search'"
          :config="{
                    borderStyle: 'around',
                    maxWidth:'400px',
                    minWidth:'400px'
                }"
          @keyup="onSearchInputKeyup"
        />
      </div>
      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
                        'margin-right': hRowMarginRight
                    }"
          >
            <th class="dt-table2--column">{{ $t('asset_type') }}</th>
            <th class="dt-table2--column">{{ $t('identifier') }}</th> 
            <th class="dt-table2--column">{{ $t('artist') }}</th>
            <th class="dt-table2--column">{{ $t('title') }}</th>
                   
          </tr>
        </thead>
        <tbody @scroll="onScroll" class="dt-table2--body">
        <tr
          class="dt-table2--row"
          v-for="(item,index) in list"
          :key="`${item.licence_track_id}${index}`"
          @click="e => onRowClicked(item)"
        >
            <td class="dt-table2--column txtov">{{item['asset_type']}}</td>
            <td class="dt-table2--column txtov">{{ item['identifier'] }}  </td>
            <td class="dt-table2--column txtov">{{item['artist']}}</td>
            <td class="dt-table2--column txtov">{{ item['title'] }}  </td>
            
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">Cancel</button>
        <!-- <button class="dt-button v1 s6" @click="onOKClick">Send All</button> -->
        
    
 
      
    </template>

  </Modal>
</template>

<script>
// import { BookingStoreNamespace as storeNS, BookingStoreNamespace } from '../../../store';
// import * as ActionTypes from '../../../store/types';

// import {mapGetters, mapActions} from 'vuex';


import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

import InputField from "@/plugins/text-field/input-field";

import { waitForAnimation, subscribeSubject } from "@/utility";

import Modal from '../../../../dt-plugins/modal/modal';
import { createModalMixin, closeModal2Route, openModal2Route } from "../../../../dt-plugins/modal/modal.mixin";
import { licenceService } from '../../services/licence.service';
import { sendMail, sendMailHref } from '../../../../utility';
import { list } from "ramda-adjunct";




export default {
  props: {
    list: {
      type: Array,
    },

  },
  components: {
    InputField,

    Modal
  },
  mixins: [
 
  ],

  data: function() {
    return {
      //list: [],
      searchString: "",
     
     
      searchSize: "single",

      assetSubject$: new Subject(),

      row_start:0,
      row_count:100
    
     

    
    
    };
  },
  mounted:async function() {
      
    // const resData= await licenceService.addLicenceLineModal1Data(this.licence_id);

    // //console.log("RESDATA:::::",this.$route.query.payload);

    // console.log(":::RESDATA:::",resData); 
    // this.list=resData.data.assets

    // console.log(":::RESDATALIST:::",this.list); 

    subscribeSubject(this, this.assetSubject$, searchString => {
      console.log("STRING ",searchString)
      licenceService.searchUnrelatedAssets(this.asset_type,undefined,undefined,searchString).then(res=>{
        this.list = res.data.assets.map(x=>{
          return{
            ...x,
            code:x[this.columnName2],
            identifier:x[this.columnName1]
            }
          
        });
      });
    })

  },
  computed: {

    
    hRowMarginRight: function() {
     
        return "38px";
    },
  
    licence_id: function() {
      return this.$route?.query?.licence_id||'';
    },


  },
  methods: {

    onCancel: function() {
  
      this.$emit("cancelled", true);
    },
    onScroll:async function(){
      console.log("SCROLL");
      this.row_count+=100;
      this.row_start+=100;
      const searchTerm =  this.searchString?'':undefined;

      const resData= await licenceService.searchUnrelatedAssets(this.asset_type,this.row_start,this.row_count,searchTerm);

      const scrollResult = resData.data.assets.map(x=>{
        return{
          ...x,
          code:x[this.columnName2],
          identifier:x[this.columnName1]
        }
        
      });

      this.list = [...this.list,...scrollResult];

    },
    onRowClicked: async function(item) {
      console.log(item);
      const payload={ licence_track_id:item.licence_track_id,licence_id:this.licence_id }
      this.$router.push({
        ...this.$route,
        query: {
          modal: "licence_income_form",
          licence_id: this.licence_id,
          licence_track_id:item.licence_track_id,
          mode: "add",
        },
      });
      
    },

    onSearchInputKeyup: function(e) {
      this.searchString = e.target.value;
      console.log(this.searchString, e.target.value,"SEARCH");
      this.assetSubject$.next(this.searchString);
    },
  }
};


</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 400px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      //background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
</style>